import Link from 'next/link';
import styles from './announcement-banner.module.scss';

const AnnouncementBanner = () => {
  return (
    <div className={styles.banner}>
      <div className={`container ${styles.inner}`}>
        <span className={styles.text}>
          Exclusive 10-Hour Jet Card Program — simplified access to private jet travel
        </span>
        <Link href="/hera-10-hour-s-jet-program" className={styles.cta}>
          View Program
          <svg
            className={styles.arrow}
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.917 7h8.166M7.583 4.083 10.5 7l-2.917 2.917"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
